import { render, staticRenderFns } from "./ExReOpenAccount.vue?vue&type=template&id=6e7900ff"
import script from "./ExReOpenAccount.vue?vue&type=script&lang=js"
export * from "./ExReOpenAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports